// src/utils/auth.js
import { jwtDecode } from "jwt-decode";

// 验证 Token 是否有效（前端角度）
export function validateToken(token) {
  if (!token) {
    console.log("Token 不存在");
    return false;
  }

  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000; // 当前时间（秒）
    
    // 检查过期时间
    if (decoded.exp && decoded.exp < now) {
      console.log("Token 已过期，过期时间:", new Date(decoded.exp * 1000));
      return false;
    }

    // 检查必要字段（如 id）
    if (!decoded.id) {
      console.log("Token 缺少id字段");
      return false;
    }

    // 检查token类型（如果是admin类型才接受）
    if (decoded.type && decoded.type !== 'admin') {
      console.log("Token 类型不正确:", decoded.type);
      return false;
    }

    console.log("Token 验证通过，用户ID:", decoded.id);
    return true;
  } catch (error) {
    console.error("Token 解析失败:", error);
    return false;
  }
}

/**
 * 检查是否有权限
 */
export function hasPermission(permissionKey) {
  // 从sessionStorage获取用户权限列表
  const userInfo = sessionStorage.getItem('userInfo')
  if (!userInfo) {
    console.log("无用户信息，权限检查失败");
    return false;
  }
  
  try {
    const { role, permissions = [] } = JSON.parse(userInfo)
    
    // 超级管理员拥有所有权限
    if (role?.role_type === 'super_admin') {
      return true
    }
    
    // 检查是否有指定权限
    const hasPerm = permissions.includes(permissionKey);
    console.log(`权限检查: ${permissionKey} -> ${hasPerm ? '有权限' : '无权限'}`);
    return hasPerm;
  } catch (error) {
    console.error('权限检查错误:', error)
    return false
  }
}

/**
 * 获取用户权限列表
 */
export function getUserPermissions() {
  const userInfo = sessionStorage.getItem('userInfo')
  if (!userInfo) return []
  
  try {
    const { permissions = [] } = JSON.parse(userInfo)
    return permissions
  } catch (error) {
    console.error('获取权限列表错误:', error)
    return []
  }
}

/**
 * 获取用户信息
 */
export function getUserInfo() {
  const userInfo = sessionStorage.getItem('userInfo')
  if (!userInfo) return null
  
  try {
    return JSON.parse(userInfo)
  } catch (error) {
    console.error('获取用户信息错误:', error)
    return null
  }
}

/**
 * 设置用户信息
 */
export function setUserInfo(userInfo) {
  try {
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
  } catch (error) {
    console.error('设置用户信息失败:', error)
  }
}

/**
 * 清除用户信息（只清除认证相关）
 */
export function clearUserInfo() {
  console.log('清除用户认证信息');
  
  // 只清除认证相关的存储
  const authItems = [
    'access-token',
    'csrf-token', 
    'refresh-token',
    'userInfo',
    'menuTree',
    'permissions',
    'routesLoaded',
    'RolePermissionAllData',
    'RoleAllData', 
    'ZoneAllData'
  ];
  
  authItems.forEach(key => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error(`移除 ${key} 失败:`, error);
    }
  });
}

/**
 * 检查是否在登录页面
 */
export function isLoginPage() {
  const path = window.location.pathname;
  return path === '/login' || path === '/register';
}

/**
 * 清理所有存储（用于初始化应用）
 */
export function clearAllAuth() {
  console.log('清理所有认证存储');
  
  // 如果当前在登录页，清理所有
  if (isLoginPage()) {
    console.log('当前在登录页，执行完整清理');
    clearUserInfo();
    
    // 清理其他可能的存储
    try {
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('menuData');
    } catch (error) {
      console.error('清理localStorage失败:', error);
    }
  }
}